import { useMemo } from "react";
import { useCartActions } from "./useCartActions";
import { useUIStore } from "../store";

export const useTotalCart = (orders: any[], total: number) => {
  const { sendOrderToWhatsApp } = useCartActions();

  const setSection = useUIStore(s => s.setSection);


  const totalItems = useMemo(
    () => orders.reduce((acc, item) => acc + item.quantity, 0),
    [orders]
  );

  return {
    total,
    totalItems,
    handleSendWhatsApp: () => sendOrderToWhatsApp(orders, total),
    openCart: () => setSection("cart")
  };
};


